<template>
  <v-container>
    <template>
      <div class="d-flex justify-space-between">
        <h2 color="#6A158E" class="page-heading">{{ object.group_name }} </h2>

        <bread-crumbs :items="breadItems"></bread-crumbs>
      </div>
      <v-card v-if="ajaxreq">
        <div class="nmt-1">
          <!-- card -->
          <v-row style="padding: 0 20px; margin-bottom: 20px">
            <v-col :md="is_free_assessment === '0' ? '6' : '12'">
              <v-card class="card-blue">
                <v-simple-table class="group-detail__table">
                  <template v-slot:default>
                    <tbody>
                      <tr v-if="false">
                        <th>Class</th>
                        <td>{{ object.class.class_name }}</td>
                      </tr>
                      <tr>
                        <th>Subject</th>
                        <td>
                          <v-chip
                            v-for="(subject, index) in object.tutor
                              .tutor_subject_group"
                            :key="index"
                            >{{ subject.subject.subject_name }}</v-chip
                          >
                        </td>
                      </tr>
                      <tr>
                        <th>Tutor</th>
                        <td>
                          {{ object.tutor.tutor_fname }}
                          {{ object.tutor.tutor_lname }}
                        </td>
                      </tr>
                      <!-- <tr>
                                            <th>Days</th>
                                            <td><v-chip v-for="day in object.days" :key="day">{{days_formatter(day)}}</v-chip> </td>
                                        </tr> -->
                      <!-- <tr> -->
                      <!-- <th>Time</th> -->
                      <!-- <td> {{object.start_time}} To {{object.end_time}} </td> -->
                      <!-- </tr> -->
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </v-col>

            <v-col md="6" v-if="is_free_assessment === '0'">
              <v-card class="card-blue">
                <v-simple-table class="group-detail__table">
                  <template v-slot:default>
                    <tbody>
                      <tr
                        v-for="student in object.group_student"
                        :key="student.id"
                      >
                        <th>
                          {{ student.student.std_fname }}
                          {{ student.student.std_lname }}
                        </th>
                        <td>
                          {{ student.student.gaurdian_email }}
                          <v-btn
                            color="success"
                            fab
                            x-small
                            dark
                            @click="removeStudent(student)"
                          >
                            <i class="fas fa-times"></i>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <v-col>
                   <!-- <v-combobox
          v-model="selectedstudents"
          :items="allstudents"
          label="Combobox"
            item-text="std_fname"
          multiple
          outlined
         :search-input.sync="searchInput"
            @input="searchInput=null"
          dense
        ></v-combobox> -->
                  <v-combobox
                    v-model="selectedstudents"
                    :items="allstudents"
                    :search-input.sync="searchInput"
                    @input="searchInput=null"
                    hide-selected
                    required
                    label="Add Students"
                    multiple
                    small-chips
                    item-value="std_id"
                    item-text="std_fname"
                  > 
                  <template slot="item" slot-scope="data">
                      {{ data.item.std_fname }} {{ data.item.std_lname }}
                    </template>
                  </v-combobox>
                  <v-btn
                    color="#F0CB00"
                    @click="addStudentsToGroup"
                    block
                    tile
                    elevation="0"
                    >Add</v-btn
                  >
                </v-col>
                <!-- <span v-if="object.students&&object.students.length<5" class="note">You may add two more students</span> -->
              </v-card>
            </v-col>
          </v-row>
          <session-table
          
            :is_free_assessment="is_free_assessment"
            :groupid="id"
            :sessions="object.group_session"
            :tutor="object.tutor"
            :students="groupStudents"
            :works="works"
            v-on:childToParent="getObject"
          ></session-table>
        </div>
        <v-dialog v-model="addToGroup" persistent width="600">
          <!-- <add-to-group-table @studentAdded="studentAdded" :id="object.id" @closeDialog="addToGroup=false"></add-to-group-table> -->
        </v-dialog>
      </v-card>
    </template>
    <v-dialog v-model="removeDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline"
          >Use Google's location service?</v-card-title
        >
        <v-card-text
          >Let Google help apps determine location. This means sending anonymous
          location data to Google, even when no apps are running.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false"
            >Disagree</v-btn
          >
          <v-btn color="green darken-1" text @click="dialog = false"
            >Agree</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import BreadCrumbs from "../../../components/BreadCrumbs";
import SessionTable from "../../../components/classes/SessionTable.vue";
import AddToGroupTable from "../../../components/students/AddToGroupTable.vue";
import { bus } from '../../../main';
export default {
  name: "GroupDetail",
  components: { AddToGroupTable, SessionTable, BreadCrumbs },
  props: {
    id: {
      type: Number,
      // required: true
    },
    is_free_assessment: {
      default: "0",
    },
  },
  data() {
    return {
      addingSession:null,
      searchInput: null,
      removeDialog: false,
      search: null,
      ajaxreq: false,
      selectedstudents: "",
      addToGroup: false,
      object: {},
      works: [],
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard",
          },
        },
        {
          text: "Groups",
          disabled: false,
          to: {
            name: "Groups",
          },
        },
        {
          text: this.$route.meta.title,
          disabled: true,
          to: {
            name: this.$route.name,
          },
        },
      ],
      classes: [],
      allstudents: [],
      groupStudents: [],
    };
  },
  methods: {
    removeStudent(item) {
      Swal2.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(result => {
        if (result.isConfirmed) {
          axios.post("removeStudent", item).then(response => {
            this.getObject();
            // this.selectedstudents = ''
          });
        }
      });
    },
    addStudentsToGroup() {
      // console.log(this.selectedstudents)
      var studentsToAdd = {
        studentsToAdd: this.selectedstudents,
      };
      axios
        .post(apiRoutes.groups.addStudents + this.id, studentsToAdd)
        .then(response => {
          // console.log(response)
          this.getObject();
          this.selectedstudents = "";
          this.addingSession=true;
              bus.$emit('addSessionStudent',true);
          // this.object = response.data.response
          // this.allstudents = response.data.students
        });
      // this.getObject()
      this.addToGroup = false;
    },
    getObject() {
      // alert(this.id)
      axios.get(apiRoutes.groups.details + this.id).then(response => {
        this.object = response.data.response;
        this.ajaxreq = true;
        this.allstudents = response.data.students;
      
        this.groupStudents = response.data.groupstudents;
        // if(this.groupStudents.length > 0){
        //   console.log("this.groupStudents.length ",this.groupStudents.length)
        //       bus.$emit('addSessionStudent');
        // }
        this.works = response.data.works;
      });
    },
  },
  mounted() {
    if (this.id) {
      this.getObject();
      console.log("is_free_assessment", this.is_free_assessment);
    }
  },
};
</script>

<style lang="scss" scoped>
.note {
  display: block;
  margin-top: 5px;
  text-align: center;
  font: 300 12px/15px Lato;
  color: #9333bb;
}

.group-detail {
  &__table {
    & th,
    & td {
      background: #b8b8b812;
    }

    & th {
      font: 500 14px/22px Gotham !important;
      color: #172b4d;
    }

    & td {
      font: 300 14px/19px Gotham !important;
      color: #172b4d;
      text-align: right;
    }
  }
}

.card-blue {
  box-shadow: 0px 3px 6px #2c28281c;
  border-radius: 10px;
  border-left: 5px solid #9333bb;
  padding: 10px 0px;
  height: 100%;
}

.page-heading {
  font: 300 22px/26px;
  font-family: "Gotham Narrow";
  color: #6a158e;
}
</style>
